import { render } from "./InputFileComponent.vue?vue&type=template&id=6ab8d5e8"
import script from "./InputFileComponent.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./InputFileComponent.vue?vue&type=script&charset=utf-8&lang=js"

import "./InputFileComponent.vue?vue&type=style&index=0&id=6ab8d5e8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__